var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-specialty-hearing.e6de6192.png","uri@2x": __webpack_public_path__ + "icon-specialty-hearing.c1c8ac1d.png","uri@3x": __webpack_public_path__ + "icon-specialty-hearing.43cf6b13.png",
    width: 20,
    height: 20
});